<template>
  <div>
    <div class="row no-gutters" v-if="produtos">
      <div class="col-lg-6 px-lg-1" v-for="l in produtos" :key="l.id_produto">
        <a href="javascript:" class="text-dark lista not-decoration" @click="$emit('openProduto', l.id_produto, l.id_categoria)">
          <div class="row no-gutters lista-conteudo">
            <div class="col-8 pr-1 produto-dados">
              <div class="produto-cabecalho">
                <produto-tag :id-tag="l.id_tag"/>
                <h4 class="h6 m-0 limite">{{l.nome_produto}}</h4>
              </div>
              <div class="mt-1 text-muted">
                <p class="tamanho-2 mb-0 limite" v-html="l.descricao_produto"></p>
                <div class="produto-restricoes">
                  <produto-consumo v-if="l.tipo_consumo > 1"
                                   :consumo="l.tipo_consumo" :tipo_pedido="sacola.tipo_pedido"/>
                  <produto-modo-pedido :modo-pedido="l.modo_pedido"/>
                </div>
              </div>
              <div class="produto-preco mt-1 mb-0">
                <span class="small mr-1" v-if="l.qtd_tabelas > 1 && l.valor > 0">A partir de</span>
                <span class="font-weight-bold" v-if="l.valor > 0" :class="{'text-success': l.valor_base > l.valor && l.qtd_tabelas === '1'}">{{l.valor | valor}}</span>
                <del class="text-muted small ml-1" v-if="l.valor_base > l.valor && l.qtd_tabelas === '1'">{{l.valor_base | valor}}</del>
                <span class="font-weight-bold" v-if="!(l.valor > 0)">Ver opções</span>
              </div>
            </div>
            <div class="col-4 text-right produto-imagem">
              <imagem-carregavel lazy :src="l.url_imagem || img_empresa || img_default" :fallback="img_empresa || img_default" :class="{'bg-primary': !l.url_imagem}" aria-hidden="true" :alt="l.nome_produto" />
            </div>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
  import ImagemCarregavel from "./ImagemCarregavel";
  import ProdutoConsumo from "./ProdutoConsumo";
  import ProdutoModoPedido from "./ProdutoModoPedido";
  import ProdutoTag from "./ProdutoTag";
  export default {
    name: 'ListaProdutos',
    components: {ImagemCarregavel, ProdutoTag, ProdutoModoPedido, ProdutoConsumo},
    props: ['produtos'],
    computed: {
      sacola() {
        return this.$store.state.sacola || {}
      },

      img_empresa() {
        return this.$store.state.empresa.url_imagem
      }
    },


  }
</script>

<style scoped>
  .lista .imagem-carregavel {
    max-width: 100%;
    width: 100px;
    height: 100px;
    object-fit: cover;
    border-radius: 12px;
  }

  .lista {
    display: block;
    cursor: pointer;
    background-color: #fff;
    border: none;
    min-height: 80px;
    border-radius: 16px;
    margin-bottom: 8px;
    box-shadow: var(--shadow);
    transition-duration: .15s;
    padding: 16px;
  }

  .lista:hover {
    box-shadow: var(--shadow-lg);
  }

  .lista-conteudo {
    min-height: 100px;
  }

  .produto-dados {
    display: flex;
    flex-direction: column;
  }

  @media (max-width: 767.98px) {
    .produto-imagem {
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
  }

  .produto-preco {
    margin-top: auto !important;
  }

  .produto-restricoes {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 4px;
  }

  .produto-preco {
    color: var(--dark);
    font-weight: 400;
  }

  @media (min-width: 768px) {
    .lista {
      padding: 12px;
      height: 168px;
      margin-bottom: 12px;
    }

    .lista-conteudo {
      height: 100%;
    }

    .produto-restricoes {
      gap: 4px;
      margin-top: 4px;
    }

    .lista .imagem-carregavel {
      width: 90px;
      height: 90px;
    }
  }

  @media (min-width: 993px) {
    .lista {
      height: 192px;
    }

    .lista .imagem-carregavel {
      width: 80px;
      height: 80px;
    }
  }

  @media (min-width: 1400px) {
    .lista {
      height: 168px;
    }
  }

</style>
